import RoundedButton from 'components/RoundedButton';

import styles from './EntriesAndStats.module.css';

const ChoosePlanSection = ({ title }: { title: string }) => (
  <div className={`textAlignCenter ${styles.choosePlanSection}`}>
    <div>
      <h3 className="aboutUsTypographyHeaderMedium">{title}</h3>
      <p className="noMargin">Choose a plan to start playing</p>
    </div>
    <RoundedButton rebrandDm2025 href="/choose-your-plan">
      Choose your plan
    </RoundedButton>
  </div>
);

export default ChoosePlanSection;
